export default __webpack_public_path__ + "static/3. Effortlessly Track Student Development 1-6efa12e543407c5a719dd9f88ae66979.png";